import { useEffect } from "react";
import { adsConfig, isAdFree, isNative } from "../lib/ads.js";

declare global {
  interface Window {
    adsbygoogle?: unknown[];
  }
}

/**
 * AdSense slot for the web build. Renders nothing on native (AdMob handles
 * banners there), when no client id is configured, or while an ad-free
 * reward is active.
 */
export function AdBanner() {
  const enabled = !isNative() && !!adsConfig.adsenseClient && !!adsConfig.adsenseSlot && !isAdFree();

  useEffect(() => {
    if (!enabled) return;
    if (!document.querySelector('script[data-adsense="1"]')) {
      const s = document.createElement("script");
      s.async = true;
      s.crossOrigin = "anonymous";
      s.dataset.adsense = "1";
      s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(adsConfig.adsenseClient)}`;
      document.head.appendChild(s);
    }
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      // blocked or not ready
    }
  }, [enabled]);

  if (!enabled) return null;
  return (
    <ins
      className="adsbygoogle ad-slot"
      style={{ display: "block" }}
      data-ad-client={adsConfig.adsenseClient}
      data-ad-slot={adsConfig.adsenseSlot}
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
}
